'use client';

import { CacheProvider } from '@emotion/react';
import Grid from '@mui/material/Grid';
import { useEffect } from 'react';

import ReservationsProvider from 'reservations/base/providers/ReservationsProvider';
import { RouterProvider } from 'reservations/base/providers/RouterProvider';
import setupAxeCore from 'utility/axeCoreTool';
import createEmotionCache from 'utility/createEmotionCache';
import { initializeDatadog } from 'utility/datadog';
import { initializeHeap } from 'utility/heap';
import { initializeSentry } from 'utility/sentry';
import { initializeSmartlook } from 'utility/smartlook';

const clientSideEmotionCache = createEmotionCache();

// istanbul ignore next
if (
  process.env.NEXT_PUBLIC_API_MOCKING === 'enabled' &&
  process.env.NODE_ENV !== 'production'
) {
  require('../mocks');
}

export const Layout = ({ children }: { children: React.ReactNode }) => {
  useEffect(() => {
    // Initialize analytics in correct order (Smartlook first for Sentry integration)
    // Each service has its own guard to prevent re-initialization
    initializeSmartlook();
    initializeSentry();
    initializeHeap();
    initializeDatadog();
    setupAxeCore();
  }, []);

  return (
    <html lang="en">
      <head>
        <meta
          name="viewport"
          content="minimum-scale=1, initial-scale=1, width=device-width"
        />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Material+Symbols+Rounded:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
        />
      </head>
      <body>
        <CacheProvider value={clientSideEmotionCache}>
          <RouterProvider>
            <ReservationsProvider>
              <Grid
                container
                direction="column"
                wrap="nowrap"
                sx={{ height: '100vh' }}
              >
                <Grid item xs={11}>
                  {children}
                </Grid>
              </Grid>
            </ReservationsProvider>
          </RouterProvider>
        </CacheProvider>
      </body>
    </html>
  );
};
